import React from 'react';
import TextInputFieldControlled from '../atoms/text-input-field-controlled'

const TextInputField = ({
	className = false,
	classNameJS = false,
	isRequired = false,
	isAutoComplete = false,
	inputName = '',
	inputType = 'text',
	pattern = null,
	placeholder = null,
	errorMsg = null,
	buttonID = null,
	onChange = null,
	valueType = null,
	saveResponse = true,
	value = null,
	showLabel = false,
	label = null,
	controlled = false
}) => {
	const createClassList = () => {
		let classList = 'ca-text-input-field';
		if (className) classList = classList + ' ca-text-input-field--' + className;
		if (classNameJS) classList = classList + ' ' + classNameJS;
		if (isRequired) classList = classList + ' js-required';
		return classList;
	};

	const autoCompleteValue = () => {
		switch (valueType) {
			case 'streetAddress':
				return 'address-line1';
			case 'streetAddress2':
				return 'address-line2';
			case 'city':
				return 'address-level2';
			case 'state':
				return 'address-level1';
			case 'zipCode':
				return 'postal-code';
			case 'phoneNumber':
				return 'tel';
			case 'email':
				return 'email';
			case 'fullName':
				return 'name';
			case 'firstName':
				return 'given-name';
			case 'lastName':
				return 'family-name';
			default:
				return 'on';
		}
	};

	const labelElement = (showLabel) ? (
		<label>{label}</label>
	) : null;

	const inputElement = (controlled) ? (
		<TextInputFieldControlled
			type={inputType}
			name={inputName}
			pattern={pattern}
			placeholder={placeholder}
			required={isRequired}
			autoComplete={isAutoComplete ? autoCompleteValue() : 'off'}
			onChangeParent={onChange}
			saveResponse={saveResponse}
			valueType={valueType}
			value={value}
		/>
	) : (
		<input
			type={inputType}
			name={inputName}
			pattern={pattern}
			placeholder={placeholder}
			required={isRequired}
			autoComplete={isAutoComplete ? autoCompleteValue() : 'off'}
			onChange={onChange}
			data-save={saveResponse}
			data-value-type={valueType}
		/>
	);

	return (
		<div className={createClassList()} data-button-id={buttonID}>
			{labelElement}
			{inputElement}
			<span className='ca-text-input-field__error-msg'>{errorMsg}</span>
		</div>
	);
};

export default TextInputField;

{
	/* <TextInputField
    classNameJS="js-show--button"
    isRequired="true || false"
    isAutoComplete="true || false"
    buttonID="button-id-goes-here"
    inputName="input-name-goes-here"
    placeholder="placeholder goes here"
    onChange={this.handleChange}
/> */
}
